import { IClasses, IClassTaskDependency } from "../models/classes";

export const canCancelClass = (
  classId: string,
  block: { Classes__r?: IClasses[] },
  allUserSelections?: { [taskId: string]: any[] }
): boolean => {
  if (!block.Classes__r) {
    return true;
  }

  const currentSelectedClassIds: string[] = [];
  if (allUserSelections) {
    Object.values(allUserSelections).forEach((selections: any[]) => {
      selections.forEach((selection: any) => {
        if (selection.selectedClassId) {
          currentSelectedClassIds.push(selection.selectedClassId);
        }
        if (selection.secondClassId) {
          currentSelectedClassIds.push(selection.secondClassId);
        }
      });
    });
  }
  const allSelectedClassIds = new Set(currentSelectedClassIds);

  const targetClass = block.Classes__r.find((cls) => cls.Id === classId);
  if (!targetClass || !targetClass.Class_Task_Dependency__r) {
    return true;
  }

  const dependency = targetClass.Class_Task_Dependency__r;

  if (dependency.Selected_Class__c === classId) {
    const optionClasses = block.Classes__r.filter(
      (cls) => cls.Class_Task_Dependency__r?.Class_option__c === classId
    );

    return !optionClasses.some((cls) => allSelectedClassIds.has(cls.Id));
  }

  if (dependency.Class_option__c === classId && dependency.Selected_Class__c) {
    return !allSelectedClassIds.has(dependency.Selected_Class__c);
  }

  return true;
};

export const getFilteredClasses = (
  block: { Classes__r?: IClasses[] },
  taskType: string,
  allUserSelections?: { [taskId: string]: any[] },
  task?: { Allow_Select_All__c?: boolean }
): IClasses[] => {
    if (taskType !== "Class Opt-in" || !block.Classes__r) {
    return block.Classes__r || [];
  }
  const currentSelectedClassIds: string[] = [];
  if (allUserSelections) {
    Object.values(allUserSelections).forEach((selections: any[]) => {
      selections.forEach((selection: any) => {
        if (selection.selectedClassId) {
          currentSelectedClassIds.push(selection.selectedClassId);
        }
        if (selection.secondClassId) {
          currentSelectedClassIds.push(selection.secondClassId);
        }
      });
    });
  }
  const allSelectedClassIds = new Set(currentSelectedClassIds);
  const dependencies = block.Classes__r.map(
    (cls: IClasses) => cls.Class_Task_Dependency__r
  ).filter((dependency: IClassTaskDependency) => dependency !== undefined);

  if (dependencies.length === 0) {
    return block.Classes__r;
  }

  const dependenciesSelectedClassIds = dependencies
    .map((dependency: IClassTaskDependency) => dependency?.Selected_Class__c)
    .filter((id: string) => id !== undefined);
  const dependenciesOptionClassIds = dependencies
    .map((dependency: IClassTaskDependency) => dependency?.Class_option__c)
    .filter((id: string) => id !== undefined);
  const dependenciesSelectedClassIdsSet = new Set(dependenciesSelectedClassIds);
  const dependenciesOptionClassIdsSet = new Set(dependenciesOptionClassIds);

  return block.Classes__r.filter((cls: IClasses) => {
    // If this class is already selected, always show it
    if (allSelectedClassIds.has(cls.Id)) {
      return true;
    }

    // If this class is an option class, check if its dependency is satisfied
    if (dependenciesOptionClassIdsSet.has(cls.Id)) {
      const dependency = cls.Class_Task_Dependency__r;
      if (dependency?.Selected_Class__c) {
        // Only show this option if its required selected class has been chosen
        return allSelectedClassIds.has(dependency.Selected_Class__c);
      }
      // If no dependency, show the option
      return true;
    }

    // For selected classes (not options), check if they should be hidden
    let shouldShow = true;
    dependenciesSelectedClassIdsSet.forEach((selectedClassId: string) => {
      if (allSelectedClassIds.has(selectedClassId)) {
        shouldShow = false;
        return;
      }
    });

    if (task?.Allow_Select_All__c) {
      dependenciesOptionClassIdsSet.forEach((optionClassId: string) => {
        if (allSelectedClassIds.has(optionClassId)) {
          shouldShow = true;
          return;
        }
      });
    }

    return shouldShow;
  });
};
